export const periodOptions = [
  { id: 6, name: '6 міс' },
  { id: 12, name: '1 рік' },
];
